import React from 'react';

/**
 * Tailwind Button Component - заміна Ant Design Button
 * 
 * @param {string} variant - 'primary' | 'secondary'
 * @param {string} size - 'default' | 'compact'
 * @param {boolean} disabled
 * @param {function} onClick
 * @param {React.ReactNode} children
 * @param {string} className - додаткові класи
 */
export const TailwindButton = ({
  variant = 'primary',
  size = 'default',
  disabled = false,
  onClick,
  children,
  className = '',
  type = 'button',
  ...props
}) => {
  const baseClasses = size === 'compact' ? 'btn-primary btn-compact' : 'btn-primary';
  const variantClasses = variant === 'secondary' ? 'btn-secondary' : baseClasses;
  
  return (
    <button
      type={type}
      className={`${variantClasses} ${className}`}
      disabled={disabled}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
};

export default TailwindButton;

